<template>
  <div>
    <!-- Search筛选 -->
    <el-form :inline="true" :model="params" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="params.sms_user_name" placeholder="APP Name" clearable style="width:240px">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">Search</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading"
      element-loading-text="Loading..." style="width: 742px;">
      <el-table-column prop="id" label="ID" width="80" align="center">
        <template slot-scope="scope">
          {{scope.row.id+1}}
        </template>
      </el-table-column>
      <el-table-column prop="file_name" label="Name" width="400">
      </el-table-column>
      <el-table-column prop="file_size" label="Size" width="100">
      </el-table-column>
      <el-table-column align="center" label="Action" width="160">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="seeFile(scope.row.file_url)">Detail</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import {
    smsFile,
  } from '../../api/apiFun'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        params: {
          sms_user_name: '',
        },
        listData: [], //User数据
      }
    },
    created() {
      this.getdata(this.params)
    },
    methods: {
      seeFile(file_url) {
        window.open(file_url, "_blank");
      },
      // 获取SMS file
      getdata(parameter) {
        this.loading = true
        this.listData = [];
        smsFile(parameter).then(res => {
          this.loading = false
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.datas.list
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Failed to get SMS file, please try again later!')
        })
      },
      // Search事件
      search() {
        this.getdata(this.params)
      },
    }
  }

</script>

<style scoped>
  .el-image__error {
    font-size: 12px !important;
  }

  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/views/sms/sms_file.vue